import React from "react";

import { clientConfig, serverConfig } from "app/config";
import { Store } from "app/main/DataProvider";
import { PageDataProvider } from "app/main/PageDataProvider";
import { createStore, getJsonFromUrl } from "app/main/functions";
import { NewsContentBlock } from "app/news/NewsContentBlock/NewsContentBlock";
import { NewsListItem } from "app/news/interfaces";
import { Page } from "app/layout/Page/Page";
import { getLatestNewsUrl } from "app/main/urls";
import { defaultMetaData, withNoIndex } from "app/main/siteMetaData";

interface Props {
    store: Store;
    news: NewsListItem[];
}

export default function NewsOverviewPage({ store, news }: Props) {
    return (
        <PageDataProvider value={store}>
            <Page metaData={withNoIndex(defaultMetaData)} title={"Börse Nachrichten"}>
                <NewsContentBlock news={news} hideHeaderLink={true} />
            </Page>
        </PageDataProvider>
    );
}

export async function getServerSideProps() {
    return {
        props: {
            store: createStore(null, "finanzen/news/", clientConfig),
            news: await getJsonFromUrl(getLatestNewsUrl(serverConfig.apiURL, 0, 50))
        }
    };
}
